const FUEL_TYPES=Object.freeze([
  Object.freeze({key:'wood',labels:Object.freeze({pl:'Drewno',en:'Wood'})}),
  Object.freeze({key:'wood_chips',labels:Object.freeze({pl:'Zrębki drewniane',en:'Wood chips'})}),
  Object.freeze({key:'wood_chunks',labels:Object.freeze({pl:'Kawałki drewna',en:'Wood chunks'})}),
  Object.freeze({key:'pellets',labels:Object.freeze({pl:'Pellet drzewny',en:'Wood pellets'})}),
  Object.freeze({key:'charcoal',labels:Object.freeze({pl:'Węgiel drzewny',en:'Charcoal'})}),
  Object.freeze({key:'briquettes',labels:Object.freeze({pl:'Brykiet',en:'Briquettes'})}),
  Object.freeze({key:'electric',labels:Object.freeze({pl:'Prąd',en:'Electric'})}),
  Object.freeze({key:'gas',labels:Object.freeze({pl:'Gaz',en:'Gas'})})
]);

const BY_KEY=new Map(FUEL_TYPES.map(item=>[item.key,item]));

function localeKey(locale){
  return String(locale||'pl').toLowerCase().startsWith('en')?'en':'pl';
}

export function listFuelTypes({locale='pl'}={}){
  const lang=localeKey(locale);
  return Object.freeze(FUEL_TYPES.map(item=>Object.freeze({
    key:item.key,
    label:item.labels[lang]||item.labels.pl
  })));
}

export function normaliseFuelTypes(values=[]){
  if(values==null)return Object.freeze([]);
  if(!Array.isArray(values))throw new TypeError('fuelTypes must be an array');
  const result=[];
  const seen=new Set();
  for(const raw of values){
    const key=String(raw||'').trim().toLowerCase();
    if(!BY_KEY.has(key))throw new TypeError(`Unsupported fuel type: ${key||'empty'}`);
    if(!seen.has(key)){seen.add(key);result.push(key);}
  }
  return Object.freeze(result);
}

export function resolveFuelType(value,{locale='pl'}={}){
  const key=String(value||'').trim().toLowerCase();
  const item=BY_KEY.get(key);
  if(!item)return null;
  const lang=localeKey(locale);
  return Object.freeze({key:item.key,label:item.labels[lang]||item.labels.pl});
}
